// WAI-ARIA tabs keyboard pattern (automatic activation) for any role="tablist".
// Activates via the tab's own click handler, so it never touches selection state.
export function targetIndex(key, index, count) {
    if (count < 2 || index < 0) return null;

    switch (key) {
        case 'ArrowRight':
            return (index + 1) % count;
        case 'ArrowLeft':
            return (index - 1 + count) % count;
        case 'Home':
            return 0;
        case 'End':
            return count - 1;
        default:
            return null;
    }
}

export default () => ({
    onKeydown(event) {
        const tabs = [...event.currentTarget.querySelectorAll('[role="tab"]')];
        const index = targetIndex(event.key, tabs.indexOf(event.target), tabs.length);
        if (index === null) return;

        event.preventDefault();
        tabs[index].click();
        tabs[index].focus();
    },
});
